import Heading from "@components/Heading";

const FAQ_ITEMS = [
  {
    question: "Estimarea de pe site este pretul final?",
    answer:
      "Nu. Este orientativa. Pretul final se stabileste dupa evaluarea telefonului in magazin sau, dupa caz, de catre furnizor.",
  },

  {
    question: "Pot trimite telefonul prin curier?",
    answer:
      "Nu. Buyback-ul se face doar in magazine, unde telefonul este evaluat direct sau trimis la furnizor.",
  },

  {
    question: "Este obligatoriu sa cumpar un telefon nou?",
    answer:
      "Nu, primesti un cupon in valoarea telefonului predat, utilizabil pentru o achizitie de aceeasi valoare sau mai mare, direct in magazin. Termenul de utilizare a voucher-ului e de 7 zile.",
  },

  {
    question: "Ce se intampla cu accesoriile si cutia?",
    answer:
      "Trebuie sa aduci doar telefonul, fara accesorii sau cutie. Pe acestea nu primesti contravaloare – fie le pastrezi si le folosesti tu, fie le reciclam noi.",
  },

  {
    question:
      "Ce se intampla cu datele mele de pe telefonul pe care il dau la buyback?",
    answer:
      "Toate informatiile de pe telefon vor fi sterse complet. Iti recomandam sa faci un back-up inainte de a-l aduce in magazin.",
  },
];

const PhoneBuyBackQA = () => (
  <div>
    <Heading
      classesProp="text-[22px] mb-[24px] text-center"
      display="h4"
      as="h4"
      title="Intrebari frecvente"
      font="semibold"
    />

    <div className="bg-white border border-black rounded-[12px] p-[20px] md:p-[30px] space-y-[18px] text-[14px] leading-[1.7] text-[#333333]">
      <ul className="list-disc pl-[18px] space-y-[10px]">
        {FAQ_ITEMS.map(({ question, answer }, index) => (
          <li key={index}>
            <span className="font-semibold">{question}</span>
            <br />
            {answer}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default PhoneBuyBackQA;
